import * as ActionType from '../../constants/actionType';

const defaultDeckInsertData = {
  id: '0',
  calibrationData: {
    x: 0,
    y: 0,
    z: 0,
  },
  isCalibrated: false,
  isSelected: false,
  isTrayAttached: true,
};

const initialState = {
  id: -1,
  description: 'initial sample tray',
  deckInserts: [
    {...defaultDeckInsertData, id: '1'},
    {...defaultDeckInsertData, id: '2'},
    {...defaultDeckInsertData, id: '3'},
    {...defaultDeckInsertData, id: '4'},
    {...defaultDeckInsertData, id: '5'},
    {...defaultDeckInsertData, id: '6'},
  ],
  lastCalibrated: '-',
  isTrayAttached: true,
  rollPitchYaw: {x: 0, y: 0, z: 0},
  thresholdRPY: {x: 0.5, y: 0.5, z: 0.5},
  currentPosition: {x: 0, y: 0, z: 0},
  trayType: 'normal',
};

export default function trayCalibrationStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_TRAY_ID:
      return {
        ...state,
        id: action.id,
      };
    case ActionType.SET_TRAY_TYPE:
      return {
        ...state,
        trayType: action.trayType,
      };
    case ActionType.SET_TRAY_DATA:
      return {...state, ...action.tray};
    case ActionType.ADD_TRAY:
      return [...state, action.tray];
    case ActionType.SET_DECK_INSERT_X_VALUE:
      return {
        ...state,
        deckInserts: state.deckInserts.map((deck) =>
          deck.id === action.deckInsertId ? {...deck, x: action.value} : deck,
        ),
      };
    case ActionType.SET_DECK_INSERT_Y_VALUE:
      return {
        ...state,
        deckInserts: state.deckInserts.map((deck) =>
          deck.id === action.deckInsertId ? {...deck, y: action.value} : deck,
        ),
      };
    case ActionType.SET_DECK_INSERT_Z_VALUE:
      return {
        ...state,
        deckInserts: state.deckInserts.map((deck) =>
          deck.id === action.deckInsertId ? {...deck, z: action.value} : deck,
        ),
      };
    case ActionType.SET_DECK_INSERT_XYZ_VALUE:
      return {
        ...state,
        deckInserts: state.deckInserts.map((deck) => {
          if (deck.id === action.deckInsertId) {
            return {
              ...deck,
              calibrationData: {
                ...deck.calibrationData,
                x: action.xPos,
                y: action.yPos,
                z: action.zPos,
              },
              isCalibrated: true,
            };
          }
          return deck;
        }),
      };
    case ActionType.SET_DECK_INSERT_CALIBRATED:
      return {
        ...state,
        deckInserts: state.deckInserts.map((deck) =>
          deck.id === action.deckInsertId ? {...deck, isCalibrated: action.status} : deck,
        ),
      };
    case ActionType.SET_ROLL_PITCH_YAW:
      return {
        ...state,
        rollPitchYaw: action.rollPitchYaw,
      };
    case ActionType.SET_THRESHOLD_RPY:
      return {
        ...state,
        thresholdRPY: action.thresholdRPY,
      };
    case ActionType.SET_LAST_CALIBRATED:
      return {
        ...state,
        lastCalibrated: action.lastCalibrated,
      };
    case ActionType.SELECT_DECK_INSERT_BY_ID:
      return {
        ...state,
        deckInserts: state.deckInserts.map((deckinsert) =>
          deckinsert.id === action.deckInsertId
            ? {...deckinsert, isSelected: action.status}
            : {...deckinsert, isSelected: false},
        ),
      };

    case ActionType.SET_DEFAULT_DECK_INSERT:
      return {...state, deckInserts: action.deckInsert};
    case ActionType.SET_DECK_INSERT:
      return {...state, deckInserts: action.deckInsert};
    case ActionType.SET_CURRENT_POSITION:
      return {...state, currentPosition: action.currentPosition};

    case ActionType.RESET_TRAYCALIBRATION:
      return {...state, ...initialState};
    case ActionType.RESTORE_TRAYCALIBRATION_STATE:
      return action.state;
    case ActionType.SET_IS_TRAY_ATTACHED:
      return {...state, isTrayAttached: action.isAttached};
    default:
      return state;
  }
}
